import { render, staticRenderFns } from "./WeekReportGraph.vue?vue&type=template&id=64ad3462&scoped=true"
import script from "./WeekReportGraph.vue?vue&type=script&lang=ts"
export * from "./WeekReportGraph.vue?vue&type=script&lang=ts"
import style0 from "./WeekReportGraph.vue?vue&type=style&index=0&id=64ad3462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ad3462",
  null
  
)

export default component.exports